var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', {
    staticClass: "my-4"
  }, [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.diagnosticBanner.icon && _vm.diagnosticBanner.icon.fileUrl || '',
      "alt": "Diagnostic Center Top Banner"
    }
  })]), _c('div', [_c('b-row', {
    staticClass: "my-4"
  }, _vm._l(_vm.diagonseCategory, function (diagnose) {
    return _c('b-col', {
      key: diagnose.category,
      attrs: {
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "diagnose-category",
      style: {
        backgroundImage: 'url(' + diagnose.backgroundImage + ')'
      },
      on: {
        "click": function ($event) {
          return _vm.diagnoseCategoryClick(diagnose.category);
        }
      }
    }, [_c('p', [_vm._v(_vm._s(diagnose.category))])])]);
  }), 1)], 1), _c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.diagnosticBanner.icon && _vm.diagnosticBanner.icon.fileUrl || '',
      "alt": "Diagnostic Center Top Banner"
    }
  })])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }